import { Component, OnDestroy } from '@angular/core';
import { CommonService } from './services/common/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnDestroy {
  title = 'aio_cloud_ui';
  constructor(private commonService:CommonService) {}
  ngOnDestroy(): void {
    this.commonService.disconnectMqtt();
  }
}
